const banner = {
  // Classic
  "banner_01_title": "Define<span>®</span><br /><em>Classic</em>",
  "banner_01_content": "โทนสีคลาสสิค สำหรับความเปล่งประกายให้ดวงตาในสไตล์คุณ",

  // Fresh
  "banner_02_title": "Define<span>®</span><br /><em>Fresh</em>",
  "banner_02_content": "โทนสีเฟรช สำหรับความสดใส ให้ดวงตาสวย มีมิติในสไตล์คุณ",

  "banner_button_01": "Filter ลองเลนส์",
  "banner_button_02": "ทำความรู้จัก Define®",
}

export default banner
